import React from "react";

type UserIconProps = {
  size?: number;
  stroke?: string;
  strokeWidth?: string;
  isOwner?: boolean;
};

export const UserIcon = (props: UserIconProps = {}) => {
  const { size = 24, stroke = "var(--blue-600)", strokeWidth = 2, isOwner = false } = props;

  return (
    <>
      {!isOwner ? (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            // stroke={"white"}
            strokeWidth={strokeWidth}
            d="M9.75 12.75C7.96875 12.75 6.5625 11.3438 6.5625 9.5625C6.5625 7.81641 7.96875 6.375 9.75 6.375C11.4961 6.375 12.9375 7.81641 12.9375 9.5625C12.9375 11.3438 11.4961 12.75 9.75 12.75ZM14.25 12C12.8203 12 11.625 10.8047 11.625 9.375C11.625 7.98047 12.8203 6.75 14.25 6.75C15.6445 6.75 16.875 7.98047 16.875 9.375C16.875 10.8047 15.6445 12 14.25 12ZM5.25 18.375C5.25 16.3477 7.73438 14.8125 9.75 14.8125C11.0273 14.8125 12.3047 15.2578 13.2188 15.9844C12.7969 16.5469 12.5625 17.25 12.5625 18V18.75C12.5625 18.8555 12.5625 18.9609 12.5977 19.0625H6.09375C5.63672 19.0625 5.25 18.6758 5.25 18.2188V18.375ZM14.25 14.25C15.8555 14.25 18.75 15.375 18.75 17.625V18.2188C18.75 18.6758 18.3633 19.0625 17.9062 19.0625H14.25C14.25 19.0273 14.25 18.9609 14.25 18.8906V18C14.25 16.7344 13.7578 15.6094 12.9844 14.7773C13.4297 14.4609 13.8516 14.25 14.25 14.25Z"
            fill="#24435D"
          />
        </svg>
      ) : (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10.5 12.75C8.33203 12.75 6.5625 10.9805 6.5625 8.8125C6.5625 6.67969 8.33203 4.875 10.5 4.875C12.6328 4.875 14.4375 6.67969 14.4375 8.8125C14.4375 10.9805 12.6328 12.75 10.5 12.75ZM5.25 18.375C5.25 15.9961 7.98047 14.4375 10.5 14.4375C12.9844 14.4375 15.75 15.9961 15.75 18.375V18.75C15.75 19.207 15.3633 19.5938 14.9062 19.5938H6.09375C5.63672 19.5938 5.25 19.207 5.25 18.75V18.375ZM18.375 9.75C17.25 9.75 16.4062 10.5938 16.4062 11.7188C16.4062 12.3516 16.6523 12.9141 17.0742 13.3008L15.9375 14.4375L16.6875 15.1875L17.4375 14.4375L18.1875 15.1875L18.9375 14.4375L18.1875 13.6875L18.6562 13.2188C18.832 13.2539 19.0078 13.2812 19.1875 13.2812C20.3125 13.2812 21.1875 12.4062 21.1875 11.2812C21.1875 10.1562 20.3125 9.75 18.375 9.75Z"
            fill="#24435D"
          />
        </svg>
      )}
    </>
  );
};
